// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb2ae347","455":"5f080ea7","488":"b1d150d5"}[chunkId] + ".chunk.js";
};